import * as React from "react";
import { SVGProps } from "react";

const OriginProtocol = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3500 3500" {...props}>
    <path
      fill="#1a82ff"
      d="M1750 0c966.5 0 1750 783.5 1750 1750s-783.5 1750-1750 1750S0 2716.5 0 1750 783.5 0 1750 0Z"
    />
    <path
      fill="#fff"
      d="M2389.8 2470.6Q2162.55 2749 1750.6 2749t-639.3-278.4Q883.9 2192.05 884 1750.5t227.2-720q227.25-278.55 639.3-278.5t639.2 278.5q227.25 278.4 227.3 720t-227.2 720.1Z"
    />
    <path
      fill="#1a82ff"
      d="M1747.4 2360.9q108.45 0 184.4-59.1t110-160.3q34-101.25 48-194.1t13.9-196.9q0-128.1-15.5-229.3l-622.9 649.1q86.4 190.5 282.1 190.6Zm6.2-1220.8q-108.45 0-184.4 59.1t-110 160.3q-34.2 101.25-48 194.1-14 92.85-13.9 196.9 0 68.55 4.4 129.4l594.1-619q-86.55-120.75-242.2-120.8Z"
    />
    <path
      fill="#1a82ff"
      d="m932.4 2369.3-76.5-73.4 580.1-604.7 76.5 73.4-580.1 604.7Zm1093-631-76.5-73.4 580.1-604.7 76.5 73.4-580.1 604.7Z"
    />
  </svg>
);

export default OriginProtocol;
